export const USER_UNAUTHORIZED_REQUEST_CUSTOM_EVENT = 'user_unauthorized_request'